import React, { Component } from "react";
import PropTypes from "prop-types";

class InputFieldTextAreaCounter extends Component {
	static propTypes = {
		textCounter: PropTypes.number.isRequired,
		charLimit: PropTypes.string.isRequired
	};
	render() {
		const { textCounter, charLimit } = this.props;
		return (
			<span className="input-field-textarea-counter">
				{textCounter}/{charLimit}
			</span>
		);
	}
}

export default InputFieldTextAreaCounter;
